export enum PaymentStatus {
  NOT_STARTED = 'NOT_STARTED',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
}
